import Vue from 'vue';
import loading from './index.vue';
var Load = Vue.extend(loading);
export default Load;